import { motion } from "framer-motion";

const dirs = { up: { y: 60, rotate: -1.5 }, down: { y: -60, rotate: 1.5 }, left: { x: -80, rotate: -2 }, right: { x: 80, rotate: 2 }, zoom: { scale: 0.85 } };
const crack = { up: "inset(45% 0% 45% 0%)", down: "inset(45% 0% 45% 0%)", left: "inset(0% 55% 0% 0%)", right: "inset(0% 0% 0% 55%)", zoom: "inset(40% 40% 40% 40%)" };

export const Reveal = ({ children, from = "up", delay = 0, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      initial={{ opacity: 0, clipPath: crack[from], filter: "blur(6px)", ...dirs[from] }}
      whileInView={{ opacity: 1, clipPath: "inset(0% 0% 0% 0%)", filter: "blur(0px)", x: 0, y: 0, scale: 1, rotate: 0 }}
      viewport={{ once: false, amount: 0.01 }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </M>
  );
};

export const Eyebrow = ({ children }) => (
  <p className="text-xs uppercase tracking-[0.3em] text-[#00C9B7] font-semibold mb-4">{children}</p>
);

export const SectionTitle = ({ eyebrow, title, className = "" }) => (
  <Reveal className={className}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <Typewriter className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl text-slate-50 leading-tight">{title}</Typewriter>
  </Reveal>
);

const typeEase = (t) => Math.floor(t * 28) / 28;

export const Typewriter = ({ children, className = "", as = "h2", ...rest }) => {
  const M = motion[as];
  return (
    <M className={className} initial="hidden" whileInView="show" viewport={{ once: false, amount: 0.01 }} {...rest}>
      <motion.span className="inline-block" variants={{ hidden: { clipPath: "inset(0% 100% 0% 0%)" }, show: { clipPath: "inset(0% 0% 0% 0%)", transition: { duration: 1.2, delay: 0.15, ease: typeEase } } }}>{children}<span className="inline-block w-[3px] h-[0.85em] bg-[#00C9B7] ml-2 align-middle animate-pulse" aria-hidden="true" /></motion.span>
    </M>
  );
};
